import { render, staticRenderFns } from "./WProductPrice.vue?vue&type=template&id=4a8bea44&scoped=true&"
import script from "./WProductPrice.vue?vue&type=script&lang=js&"
export * from "./WProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bea44",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WMoney from '@/components/WMoney.vue'
import WSelect from '@/components/WSelect.vue'
autoInstallComponents(component, {WMoney,WSelect})
